import { cn } from './listingCardUtils.js';

export default function ListingCardRating({ listing, show = {}, variant = 'content' }) {
  if (!show.rating || !listing.rating) return null;

  return (
    <div className={cn('flex items-center gap-1.5 text-sm', variant === 'hero' ? 'text-white/85' : 'text-slate-700')}>
      <span className="text-amber-500" aria-hidden="true">★</span>
      <span className="font-semibold">{listing.rating}</span>
      {show.reviews && listing.reviewCount ? (
        <span className={cn(variant === 'hero' ? 'text-white/70' : 'text-slate-500')}>
          ({listing.reviewCount})
        </span>
      ) : null}
    </div>
  );
}
